export const COUPON_FIELDS = {
  coupon: {
    label: "If you have a coupon code please apply it below",
    placeholder: "Coupon code",
  },
};
